import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { Http, Response, Headers, RequestOptions } from "@angular/http";
import { AuthService } from '../services/permission/authService.service';
import { Subject } from 'rxjs';
import { GlobalState } from '../../global.state';
import { Observable, Subscriber, of } from "rxjs";
import { Employee, Customer, Room, Service, Series, SeriesSales, Treatment, Followup, Prescription, Disease, Medication, HolidayModel, TransferModel } from '../interfaces';
import { TTLCacheService } from '../services/cache.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { mergeMap, tap } from 'rxjs/operators';


@Injectable()
export class MasterRepo {
    public _employeeList: Array<Employee> = [];
    public _followupList: Array<Followup> = [];
    public _treatmentList: Array<Treatment> = [];
    public _customerList: Array<Customer> = [];
    public _prescriptionList: Array<Prescription> = [];
    public _roomList: Array<Room> = [];
    public _serviceList: Array<Service> = [];
    public _seriesList: Array<Series> = [];
    public _seriesSalesList: Array<SeriesSales> = [];
    private Subscriptions: any[];
    public _diseaseList: Array<Disease> = [];
    public _medicationList: Array<Medication> = [];
    public _holidayList: Array<HolidayModel> = [];
    public _transferList: Array<TransferModel> = [];

    public selected_Date: string;

    //constructor 
    constructor(private http: HttpClient, private authService: AuthService, private cache:TTLCacheService, private state: GlobalState) {

    }

    public getRole() {
        //console.log(localStorage.getItem('USER_PROFILE'));
        //console.log(sessionStorage.getItem('USER_PROFILE'));
        return sessionStorage.getItem('USER_PROFILE');
    }

    public get contentUrl(): string {
        let url = this.state.getGlobalSetting("contentUrl");
        let contentUrl = "";

        if (!!url && url.length > 0) { contentUrl = url[0] };
        //console.log({ contentUrl: contentUrl })
        return contentUrl
    }

    public get apiUrl(): string {
        let url = this.state.getGlobalSetting("apiUrl");
        let apiUrl = "";

        if (!!url && url.length > 0) { apiUrl = url[0] };
        //console.log({ apiUrl: apiUrl })
        return apiUrl
    }
    public getRequestOption() {
        let headers: HttpHeaders = new HttpHeaders({ 'Content-type': 'application/json', 'Authorization': this.authService.getAuth().token })
        //console.log({ headers: headers });
        return { headers: headers };
    }


    public getEmployeeList(refresh = false) {
        return this.http.get(this.apiUrl + '/getEmployeeList', this.getRequestOption())
    }

     public getEmployeeRoster(branchId:string, date :string) {
        return this.http.get(this.apiUrl + `/getEmployeeRoster?branchId=${branchId}&date=${date}`, this.getRequestOption())
    }
    public getCustomerList(refresh = false) {
        return this.http.get(this.apiUrl + '/getCustomerList', this.getRequestOption())

    }
    public getPagedCustomerList(pageNo: Number, rowCount: Number, name: string, mobile: string) {
        var nameFilter = "";
        var mobileFilter = "";
        if (name && name.length > 0)
            nameFilter = "&NAME_Like=" + encodeURIComponent(name);
        if (mobile && mobile.length > 0)
            mobileFilter = "&MOBILE_Like=" + encodeURIComponent(mobile);

        return this.http.get(this.apiUrl + "/getCustomerListPaged?currentPage=" + pageNo + "&maxResultCount=" + rowCount +  nameFilter + mobileFilter, this.getRequestOption())
    }
    public getPrescriptionList(refresh = false) {
        return this.http.get(this.apiUrl + '/getPrescriptionList', this.getRequestOption())

    }
    public getRoomList(refresh = false) {

        return this.http.get(this.apiUrl + '/getRoomList?includeInactive=true', this.getRequestOption())
    }
    public getServiceList(refresh = false) {
        return this.http.get(this.apiUrl + '/getServiceList', this.getRequestOption())
    }
    public getEmployeeServices(id: number){
        return this.http.get(this.apiUrl + `/getEmployeeService?EMPLOYEEID=${id}`, this.getRequestOption())
    }
    public getRoomServices(id: number){
        return this.http.get(this.apiUrl + `/getRoomService?ROOMID=${id}`, this.getRequestOption())
    }
    public getServiceListNew() {
        return this.http.get(this.apiUrl + '/getServiceList', this.getRequestOption())
    }
    public getfollowupList(refresh = false) {
        return this.http.get(this.apiUrl + '/getFollowupList', this.getRequestOption())
    }
    public getSeriesList(refresh = false) {
        return this.http.get(this.apiUrl + '/getSeriesList', this.getRequestOption())
    }
    public getSeriesSalesList(refresh = false) {
        return this.http.get(this.apiUrl + '/getSeriesSalesList', this.getRequestOption())
    }
    public getItemList(refresh = false) {
        return this.http.get(this.apiUrl + '/getProduct', this.getRequestOption())
    }
    public getSeriesItemList(refresh = false) {
        return this.http.get(this.apiUrl + '/getSeriesItemList', this.getRequestOption())
    }
    public getFollowUpList(TreatmentDate) {

        return this.http.get(this.apiUrl + '/getFollowUpList', this.getRequestOption())
    }

    public getTreatmentListDetails(date: string) {
        return this.http.get(this.apiUrl + '/getTreatmentListDetails?date=' + date, this.getRequestOption())
    }



    public getTreatmentList(refresh = false) {
        return this.http.get(this.apiUrl + '/getTreatmentList', this.getRequestOption())
    }
    public getDiseaseList(refresh = false) {

        return this.http.get(this.apiUrl + '/GetDiseaseList', this.getRequestOption())
    }

    public getHolidayList(refresh = false) {

        return this.http.get(this.apiUrl + '/GetHolidayList', this.getRequestOption())
    }

    public getServices(branchId:string):Observable<Service[]> {
        const cacheKey = `service_${branchId}`;
        const cached = this.cache.get<Service[]>(cacheKey);
    
        if (cached) {
          return of(cached);
        }
        return this.http.get(this.apiUrl + `/GetServiceList?branchId=${branchId}`, this.getRequestOption())
        .pipe(
            mergeMap((res:any) => {
                this.cache.set(cacheKey, res, 10); // TTL: 10 minutes
                return of(res);
            })
        );
    }
    public getBranchList() {
        return this.http.get(this.apiUrl + "/getOutlet", this.getRequestOption())
    }

    public getEmployees() {
        return this.http.get(this.apiUrl + "/getEmployees", this.getRequestOption())
    }

    public getEmployeeListNew(branchId:string): Observable<Employee[]> {
        const cacheKey = `employees_${branchId}`;
        const cached = this.cache.get<Employee[]>(cacheKey);
    
        if (cached) {
          return of(cached);
        }
    
        console.log(this.apiUrl + `/getEmployeeList?branchId=${branchId}`);
        return this.http.get(this.apiUrl + `/getEmployeeList?branchId=${branchId}`, this.getRequestOption())
           .pipe(
            tap((res:any) => {
                this.cache.set(cacheKey, res, 10); // TTL: 10 minutes
                console.log('API RESPONSE', res);
            })
        );
    }

    public getRoomListNew(branchId:string): Observable<Room[]> {
        const cacheKey = `room_${branchId}`;
        const cached = this.cache.get<Room[]>(cacheKey);
    
        if (cached) {
          return of(cached);
        }
    
        return this.http.get(this.apiUrl + `/getRoomList?branchId=${branchId}`, this.getRequestOption())
        .pipe(
            mergeMap((res:any) => {
                this.cache.set(cacheKey, res, 10); // TTL: 10 minutes
                return of(res);
            })
        );
    }

    public getAvailableEmployees(branchId:string, serviceId : Number, appDate: Date, appTime:string): Observable<Employee> {
        let body = { branchId, serviceId, appDate,appTime };
        return this.http.post<Employee>(this.apiUrl + `/getAvailableEmployee`, body, this.getRequestOption())
    }

    public getAvailableRooms(branchId:string, serviceId : Number, appDate: Date, appTime:string) : Observable<Room> {
        let body = { branchId, serviceId, appDate,appTime };
        return this.http.post<Room>(this.apiUrl + `/getAvailableRooms`, body, this.getRequestOption())
    }
    
    public getRooms() {
        return this.http.get(this.apiUrl + "/getRooms", this.getRequestOption())
    }

    public getTimeSlotForAppointment(model : any){
        return this.http.post(this.apiUrl + '/getTimeSlotForAppointment', model, this.getRequestOption());
    }

    public GetAppointmentForCheckIn(model : any){
        return this.http.post(this.apiUrl + '/GetAppointmentForCheckIn', model, this.getRequestOption());
    }

    public GetAppointmetRequests(branchId : string[]){
        return this.http.post(this.apiUrl + `/AppointmentRequest/get`, branchId, this.getRequestOption())
    }

    public GetAppointmetDetail(cartId : string){
        return this.http.get(this.apiUrl + `/AppointmentRequest/detail?cartId=${cartId}`, this.getRequestOption())
    }

    public ApproveAppointment(cartId:string, scheduleId:Number){
        const body ={cartId, scheduleId }
        return this.http.post(this.apiUrl + `/AppointmentRequest/approve`, body, this.getRequestOption())
    }

    public RejectAppointment(cartId:string, remarks:string){
        const body = { cartId, remarks };
        return this.http.post(this.apiUrl + `/AppointmentRequest/reject`, body, this.getRequestOption())
    }

    public GetAllCheckIns(branchId : string[]){
        return this.http.post(this.apiUrl + `/GetCheckIns`,branchId, this.getRequestOption())
    }

    public GetEmpTransferList(branches : string[]){
        return this.http.post(this.apiUrl + `/GetTransferList`,branches, this.getRequestOption())
    }

    public GetTransferEmp(branch : string, date : string, serviceId:number){
        return this.http.get(this.apiUrl + `/GetTransferList?branch=${branch}&date=${date}&serviceId=${serviceId}`, this.getRequestOption())
    }

    public getTreatmentHistory(cusid: string) {
        return this.http.get(this.apiUrl + '/getPatientTreatmentHistory?id=' + cusid + '&currentPage=1&maxResultCount=10', this.getRequestOption())
    }

    public sendTreatmentEmai(model) {
        return this.http.post(this.apiUrl + '/sendTreatmentEmail', model, this.getRequestOption()).subscribe(res => console.log(res));
        //  return this.http.post(this.apiUrl + '/api/sendTreatmentEmai', model, this.getRequestOption());
    }

    public getMedicationList(refresh = false) {

        return this.http.get(this.apiUrl + '/GetMedicationList', this.getRequestOption())
    }

    public getCustomerById(cusid: string) {
        return this.http.get(this.apiUrl + '/getCustomer?id=' + cusid, this.getRequestOption())
    }

    public getFormPreferences(id: string) {
        return this.http.get(this.apiUrl + '/getFormPreference/' + id, this.getRequestOption())
    }

    empListHttp$ = this.http.get(this.apiUrl + '/getEmployeeList', this.getRequestOption());
    cusListHttp$ = this.http.get(this.apiUrl + '/getCustomerList', this.getRequestOption());
    roomListHttp$ = this.http.get(this.apiUrl + '/getRoomList', this.getRequestOption());
    serListHttp$ = this.http.get(this.apiUrl + '/getServiceList', this.getRequestOption());
    presListHttp$ = this.http.get(this.apiUrl + '/getPrescriptionList', this.getRequestOption());

    public refreshEmployeeList() {
        var elist: Employee[] = [];
        this.http.get(this.apiUrl + '/getEmployeeList', this.getRequestOption())
            
            .subscribe((data) => { elist.push(<Employee>data); },
                Error => console.log(Error),
                () => { this._employeeList = elist; })



    }

    public refreshPrescriptionList() {
        var prescriptionList: Prescription[] = [];
        this.presListHttp$.subscribe((data) => { prescriptionList.push(<Prescription>data); },
            Error => console.log(Error),
            () => { this._prescriptionList = prescriptionList; })
    }


    public refreshCustomerList() {
        var clist: Customer[] = [];
        this.cusListHttp$.subscribe((data) => { clist.push(<Customer>data); },
            Error => console.log(Error),
            () => { this._customerList = clist; })
    }
    public refreshRoomList() {
        var rlist: Room[] = [];
        this.roomListHttp$.subscribe((data) => { rlist.push(<Room>data); },
            Error => console.log(Error),
            () => { this._roomList = rlist; })
    }
    public refreshServiceList() {
        var slist: Service[] = [];
        this.serListHttp$.subscribe((data) => { slist.push(<Service>data); },
            Error => console.log(Error),
            () => { this._serviceList = slist; })
    }


    public checkUserValid() {
        return new Observable((observer: Subscriber<boolean>) => {
            this.http.get(this.apiUrl + '/checkLogin',
                this.getRequestOption())
                .subscribe(data => {
                    this.state.setGlobalSetting('LoggedIn', ["true"]);
                    observer.next(true);
                    observer.complete();
                }, Error => {
                    observer.next(false);
                    observer.complete();
                }, () => {
                    observer.complete();
                })
        })
    }

    postmaster(mode, dataToSave, postUrl) {

        let res = { status: "error", result: "" }
        let returnSubject: Subject<any> = new Subject();
        let opt = this.getRequestOption();
        let hd: Headers = new Headers({ 'Content-Type': 'application/json' });
        let op: RequestOptions = new RequestOptions()
        let bodyData = { mode: mode, data: dataToSave };
        //console.log(bodyData);
        this.http.post(this.apiUrl + postUrl, bodyData, this.getRequestOption())
            .subscribe((retData:any) => {
                if (retData.status == "ok") {
                    res.status = "ok";
                    res.result = retData.result
                    returnSubject.next(res);
                    returnSubject.unsubscribe();
                }
                else {
                    res.status = "error1"; res.result = retData.result;
                    //console.log(res);
                    returnSubject.next(res);
                    returnSubject.unsubscribe();
                }
            },
                error => {
                    res.status = "error2";
                    res.result = this.handleWebError(error);
                    //console.log(res);
                    returnSubject.next(res);
                    returnSubject.unsubscribe();
                }
            );
        return returnSubject;

    }

    postMasterAsync(mode, dataToSave, postUrl) {

        let res = { status: "error", result: "" }
        let opt = this.getRequestOption();
        let hd: Headers = new Headers({ 'Content-Type': 'application/json' });
        let op: RequestOptions = new RequestOptions()
        let bodyData = { mode: mode, data: dataToSave };
        //console.log(bodyData);
        return this.http.post(this.apiUrl + postUrl, bodyData, this.getRequestOption()).toPromise<any>();
    }


    postform(mode, dataToSave, postUrl, files) {
        let res = { status: "error", result: "" }
        var formdata = new FormData();
        formdata.append("data", JSON.stringify(dataToSave));
        if (files != null) {
            for (let i = 0; i < files.length; i++) {
                formdata.append(files[i].name, files[i]);
            }
        }
        console.log(formdata, "formdata");
        let headers: HttpHeaders = new HttpHeaders({ 'Authorization': this.authService.getAuth().token});
        let returnSubject: Subject<any> = new Subject();
        this.http.post(this.apiUrl + postUrl, formdata, { headers: headers })
            .subscribe((retData:any) => {
                if (retData.status == "ok") {
                    res.status = "ok";
                    res.result = retData.result
                    returnSubject.next(res);
                    returnSubject.unsubscribe();
                }
                else {
                    res.status = "error1"; res.result = retData.result;
                    console.log(res);
                    returnSubject.next(res);
                    returnSubject.unsubscribe();
                }
            },
                error => {
                    res.status = "error2", res.result = error;
                    console.log(res);
                    returnSubject.next(res);
                    returnSubject.unsubscribe();
                }
            );
        return returnSubject;

    }
    public getTableSetting() {
        return { StartingTime: "9AM", ClosingTime: "8PM", MinuteCellWidth: 25 };
    }
    public TimeScheduleHeader(startingTime, closingTime) {
        let hourHeaderList = [];
        let noOfTimeHeaderInHour = 0;
        let totalNoOfMinCell = 0;
        let minList = [];

        var st = parseInt(startingTime.slice(0, -2));
        var stp = startingTime.slice(-2);
        var ct = parseInt(closingTime.slice(0, -2));
        var ctp = closingTime.slice(-2);
        if (ctp.toUpperCase() == "PM") { ct = ct + 12; }
        if (stp.toUpperCase() == "PM") { st = st + 12; }
        let starttime = st;
        let ap = stp.toUpperCase();
        for (let h = st; h < ct; h++) {
            let pred = "AM";
            if (h >= 12) { pred = "PM"; }

            hourHeaderList.push((h > 12 ? (h - 12) : h) + pred);
        }
        noOfTimeHeaderInHour = ct - st;
        totalNoOfMinCell = noOfTimeHeaderInHour * 4;
        for (let j = 1; j <= noOfTimeHeaderInHour; j++) {
            if (starttime >= 12) {
                ap = "PM";
            }
            for (let i = 0; i < 4; i++) {

                minList.push({ min: i * 15, booked: 0, startTime: starttime, minPart: i + 1, ampm: ap });
            }
            if (starttime == 12) { starttime = 0; ap = "PM" }
            starttime++;
        }
        return { hourHeaderList: hourHeaderList, minList: minList };

    }
    setBookedInCell(initialCellList, starttime, endtime, duration, room, service, customer, minuteCellWidth) {
        var s = starttime.slice(0, -5);
        var ampm = starttime.slice(-2);
        var onlyMin = parseInt(starttime.slice(-4).slice(0, -2));

        var noOfBLock = Math.ceil(duration / 15);
        console.log({ noOfBLock: noOfBLock });
        let isBooked = 0;
        let skip = 0;
        for (let t of initialCellList) {
            //console.log({Tstarttime:t.startTime, Tampm :t.ampm, starttime:s, ampm:ampm.toUpperCase(), onlyMin:onlyMin, minPart:t.minPart});
            if (t.startTime == s && t.ampm == ampm.toUpperCase()) {
                if (onlyMin == 0 && t.minPart == 1) {
                    t.booked = 1;
                    isBooked = 1;
                    t.colspan = noOfBLock;
                    skip = 1;
                    t.width = minuteCellWidth * noOfBLock + 'px';
                    t.room = room;
                    t.service = service;
                    t.customer = customer;
                }
                else if (onlyMin <= 15 && onlyMin > 0 && t.minPart == 2) {
                    t.booked = 1; isBooked = 1;
                    t.colspan = noOfBLock; skip = 1;
                    t.width = minuteCellWidth * noOfBLock + 'px';
                    t.room = room;
                    t.service = service;
                    t.customer = customer;
                }
                else if (onlyMin <= 30 && onlyMin > 15 && t.minPart == 3) {
                    t.booked = 1; isBooked = 1;
                    t.colspan = noOfBLock; skip = 1; t.width = minuteCellWidth * noOfBLock + 'px';
                    t.room = room;
                    t.service = service;
                    t.customer = customer;
                }
                else if (onlyMin <= 45 && onlyMin > 30 && t.minPart == 4) {
                    t.booked = 1; isBooked = 1;
                    t.colspan = noOfBLock; skip = 1; t.width = minuteCellWidth * noOfBLock + 'px';
                    t.room = room;
                    t.service = service;
                    t.customer = customer;
                }

            }
            if (isBooked == 1 && noOfBLock > 0) {
                if (skip == 1) { skip = 0; }
                else {

                    t.booked = 1;
                    t.cellToSplice = 1;
                }
                noOfBLock = noOfBLock - 1;
                if (noOfBLock == 0) { isBooked = 0; }

            }
        }
        return initialCellList;
    }

    saveDate(date: string) {
        let new_date: string = date;
        this.selected_Date = new_date;
        console.log('after date', date, typeof date)
    }

    getDate() {
        console.log(this.selected_Date);
        return this.selected_Date;
    }

    public getSmsCredit() {
        return this.http.get(this.apiUrl + '/getSmsCredit', this.getRequestOption())
    }


    toBSDate(date:Date):string;
    toBSDate(date:string):string;

    public toBSDate(date: any){
        if(typeof date !== "string"){
            let adDate : string =`${date.getFullYear().toString()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2,'0')}`;
            return this.toBSDate(adDate)
        }
        else {
            var nepFunction = require('../../../assets/nepali-date-picker/nepali.datepicker.v3.5.min.js')
            var bsDate = nepFunction.ad2bs(date);
            return bsDate.year + '-' + bsDate.month.toString().padStart(2,'0') + '-' + bsDate.day.toString().padStart(2,'0');
        }
    }

    public toADDate(bsDate:string):string{
        var nepFunction = require('../../../assets/nepali-date-picker/nepali.datepicker.v3.5.min.js')
        var adDate = nepFunction.bs2ad(bsDate);
        return adDate.year + '-' + adDate.month.toString().padStart(2,'0') + '-' + adDate.day.toString().padStart(2,'0');
    }

    handleWebError(error):string{
        if(error.status === 404){
            return error.statusText;
        }
        else if(error._body){
            var eResponse = JSON.parse(error._body);
            if(eResponse && eResponse.result){
                return eResponse.result;
            }
        }
        return JSON.stringify(error);
    }  
}